import feeExpirationAlert from '@/api/fee-expiration-alert'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )

    return feeExpirationAlert.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  }
}
